import { getMsgDeskRuntime } from '@/msgdeskRuntime'

type LegacySlotRegistry = {
  registerSlot: (slotId: string, el: HTMLElement | null) => void
}

export function legacySlotRef(slotId: string) {
  return (el: HTMLElement | null) => {
    getMsgDeskRuntime().getReactUiFacade<LegacySlotRegistry>()?.registerSlot(slotId, el)
  }
}
